import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Liens de suivi',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Réseaux sociaux',
  },
  form: {
    utm_source: {
      label: 'Source',
      placeholder: 'Sélectionner la source',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Autres réseaux sociaux',
        [CustomUtmSource.Other]: 'Autre',
      },
    },
    utm_source_details: {
      label: 'Source personnalisée',
      placeholder: 'Saisir la source',
    },
    target_product: {
      label: 'Cible',
      placeholder: 'Sélectionner la cible',
    },
    target_url: {
      label: 'URL cible',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Support',
      placeholder: 'Saisir le support',
    },
    utm_campaign: {
      label: 'Campagne',
      placeholder: 'Saisir la campagne',
    },
  },
  fields: {
    utm_source: 'Source',
    target_product: 'Cible',
    type: 'Type',
    utm_medium: 'Support',
    utm_campaign: 'Campagne',
    utm_referrer_id: 'ID référent',
  },
  buttons: {
    create_auto_links: 'Créer des liens automatiques',
    create_link: 'Créer un lien',
    create: 'Créer',
    update: 'Mettre à jour',
    copy_link: 'Copier le lien',
    download_qr_code: 'Télécharger le QR code',
    edit: 'Modifier',
  },
  modals: {
    auto_links_creation: {
      title: 'Êtes-vous sûr ?',
      description:
        "Assurez-vous d'avoir finalisé la configuration de la boutique (sous-domaine / domaine vitrine) ; les modifier après la création des liens n'affectera pas automatiquement les liens existants !",
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
    link_got_copied: 'Lien copié !',
    failed_to_download_qr_code: 'Échec du téléchargement du QR code',
  },
};
